module.exports = __webpack_public_path__ + "img/order-expired-clock.2edd9c82.png";